<div class="row pt-3">
    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@c83b838d845690bcb897f775f53b5316535306dc" t="c83b838d845690bcb897f775f53b5316535306dc">First Name</tsl-label>
            <input required tslInput fullWidth shape="round" type="text" [formControl]="firstNameControl"
                placeholder="First Name" tPlaceholder="c83b838d845690bcb897f775f53b5316535306dc" i18n-placeholder="@@c83b838d845690bcb897f775f53b5316535306dc" maxlength="30" />
            <tsl-hint align="end" class="max-length-hint">{{firstNameControl.value?.length || 0}} / 30
            </tsl-hint>
            <tsl-error *ngIf="firstNameControl.errors && ( firstNameControl.dirty ||  firstNameControl.touched)">
                <span i18n="@@14e192cb676257db8fed3dad864f5e5f8a17e119" t="14e192cb676257db8fed3dad864f5e5f8a17e119">First Name is Required </span>
            </tsl-error>
            <tsl-error
                *ngIf="firstNameControl.errors && !firstNameControl.errors.required && firstNameControl.errors.pattern">
                <span i18n="@@f172f71e83faaf7a7d495a20cd395ebb3250ed54" t="f172f71e83faaf7a7d495a20cd395ebb3250ed54">Only alphabets and space characters allowed</span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@166b2cc65003221ff5f3ec05d5baca41e6821396" t="166b2cc65003221ff5f3ec05d5baca41e6821396">Last Name</tsl-label>
            <input required tslInput fullWidth shape="round" type="text" [formControl]="lastNameControl"
                placeholder="Last Name" tPlaceholder="166b2cc65003221ff5f3ec05d5baca41e6821396" i18n-placeholder="@@166b2cc65003221ff5f3ec05d5baca41e6821396" maxlength="30" />
            <tsl-hint align="end" class="max-length-hint">{{lastNameControl.value?.length || 0}} / 30</tsl-hint>
            <tsl-error *ngIf="lastNameControl.errors && ( lastNameControl.dirty ||  lastNameControl.touched)">
                <span>Last Name is Required </span>
            </tsl-error>
            <tsl-error
                *ngIf="lastNameControl.errors && !lastNameControl.errors.required && lastNameControl.errors.pattern">
                <span i18n="@@f172f71e83faaf7a7d495a20cd395ebb3250ed54" t="f172f71e83faaf7a7d495a20cd395ebb3250ed54">Only alphabets and space characters allowed</span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@244aae9346da82b0922506c2d2581373a15641cc" t="244aae9346da82b0922506c2d2581373a15641cc">Email</tsl-label>
            <input required tslInput fullWidth shape="round" type="email" placeholder="Email" tPlaceholder="244aae9346da82b0922506c2d2581373a15641cc" i18n-placeholder="@@244aae9346da82b0922506c2d2581373a15641cc"
                [formControl]="emailControl" maxlength="256" />
            <mat-icon *ngIf="showEmailInfo" matTooltip="{{emailInfo}}" matSuffix>info_fill</mat-icon>
            <tsl-hint align="end" class="max-length-hint">{{emailControl.value?.length || 0}} / 256
            </tsl-hint>
            <tsl-error
                *ngIf="emailControl.errors && emailControl.errors.required &&  (emailControl.dirty ||  emailControl.touched)">
                <span i18n="@@d068093d620c1bdc4c4a2a50efd1fe4fbf0a0f71" t="d068093d620c1bdc4c4a2a50efd1fe4fbf0a0f71">Email is Required </span>
            </tsl-error>
            <tsl-error
                *ngIf="emailControl.errors && emailControl.errors.email &&  (emailControl.dirty ||  emailControl.touched)">
                <span i18n="@@e5d28518a74d03d6ba089a7046ea9e38fbc026e4" t="e5d28518a74d03d6ba089a7046ea9e38fbc026e4">Enter a valid email </span>
            </tsl-error>
            <tsl-error
                *ngIf="emailControl.errors && emailControl.errors.requiredDomain &&  (emailControl.dirty ||  emailControl.touched)">
                <span><span i18n="@@5899177039985151905" t="5899177039985151905">Email domain must be equal to </span>{{requiredEmailDomain}} </span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@917fe77920bc5c5f63200a05b50ac35b1d0e9156" t="917fe77920bc5c5f63200a05b50ac35b1d0e9156">Email Communication Language</tsl-label>
            <tsl-select shape="round" placeholder="Email Communication Language" [formControl]="languageCodeControl"
                tPlaceholder="917fe77920bc5c5f63200a05b50ac35b1d0e9156" i18n-placeholder="@@917fe77920bc5c5f63200a05b50ac35b1d0e9156">
                <tsl-option>Select</tsl-option>
                <tsl-option *ngFor="let language of languages" [value]="language.id">{{language.name}}
                </tsl-option>
            </tsl-select>
            <tsl-error
                *ngIf="languageCodeControl.errors && (languageCodeControl.dirty ||  languageCodeControl.touched)">
                <span i18n="@@b83141f14cc364caf1fe6a920dc936209d1c3958" t="b83141f14cc364caf1fe6a920dc936209d1c3958">Language is Required </span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@20d9489fdbfc121f7c504271b36691515d02f632" t="20d9489fdbfc121f7c504271b36691515d02f632">Job Title</tsl-label>
            <input required tslInput fullWidth shape="round" type="text" placeholder="Job Title"
                [formControl]="jobTitleControl" maxlength="100" tPlaceholder="20d9489fdbfc121f7c504271b36691515d02f632" i18n-placeholder="@@20d9489fdbfc121f7c504271b36691515d02f632" />
            <tsl-hint align="end" class="max-length-hint">{{jobTitleControl.value?.length || 0}} / 100
            </tsl-hint>
            <tsl-error *ngIf="jobTitleControl.errors && (jobTitleControl.dirty ||  jobTitleControl.touched)">
                <span i18n="@@cd38fe5de7b920fd0f7059e1b3148bb6f3609b99" t="cd38fe5de7b920fd0f7059e1b3148bb6f3609b99">Job Title is Required </span>
            </tsl-error>
        </tsl-form-field>
    </div>


    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@7ef67f76ab81c082a91782412af3639cca2126de" t="7ef67f76ab81c082a91782412af3639cca2126de">Mobile</tsl-label>
            <input tslInput fullWidth shape="round" type="text" placeholder="Mobile" [formControl]="mobileControl"
                maxlength="30" tPlaceholder="7ef67f76ab81c082a91782412af3639cca2126de" i18n-placeholder="@@7ef67f76ab81c082a91782412af3639cca2126de" />
            <tsl-hint align="end" class="max-length-hint">{{mobileControl.value?.length || 0}} / 30
            </tsl-hint>
            <tsl-error *ngIf="mobileControl.errors && mobileControl.errors.pattern">
                <span i18n="@@a89e72af10bfd49ff39397cd54981b8d6c2c8f86" t="a89e72af10bfd49ff39397cd54981b8d6c2c8f86">Only alphanumeric, underscore, space and # ( ) + - characters allowed</span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@6934d8edd276d59e050006fe91b695ebad0218f8" t="6934d8edd276d59e050006fe91b695ebad0218f8">Phone</tsl-label>
            <input required tslInput fullWidth shape="round" type="text" placeholder="Phone"
                [formControl]="phoneControl" maxlength="30" tPlaceholder="6934d8edd276d59e050006fe91b695ebad0218f8" i18n-placeholder="@@6934d8edd276d59e050006fe91b695ebad0218f8" />
            <tsl-hint align="end" class="max-length-hint">{{phoneControl.value?.length || 0}} / 30
            </tsl-hint>
            <tsl-error *ngIf=" phoneControl.errors && ( phoneControl.dirty ||  phoneControl.touched)">
                <span i18n="@@060c3b509b8af218451c50408ce9ff39b779ba10" t="060c3b509b8af218451c50408ce9ff39b779ba10">Phone is Required </span>
            </tsl-error>
            <tsl-error *ngIf="phoneControl.errors && !phoneControl.errors.required && phoneControl.errors.pattern">
                <span i18n="@@a89e72af10bfd49ff39397cd54981b8d6c2c8f86" t="a89e72af10bfd49ff39397cd54981b8d6c2c8f86">Only alphanumeric, underscore, space and # ( ) + - characters allowed</span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@c51dd3c995cd973b8678838ac584270932b410c3" t="c51dd3c995cd973b8678838ac584270932b410c3">Fax</tsl-label>
            <input tslInput fullWidth shape="round" type="text" placeholder="Fax" tPlaceholder="c51dd3c995cd973b8678838ac584270932b410c3" i18n-placeholder="@@c51dd3c995cd973b8678838ac584270932b410c3" [formControl]="faxControl"
                maxlength="30" />
            <tsl-hint align="end" class="max-length-hint">{{faxControl.value?.length || 0}} / 30</tsl-hint>
            <tsl-error *ngIf="faxControl.errors && faxControl.errors.pattern">
                <span i18n="@@a89e72af10bfd49ff39397cd54981b8d6c2c8f86" t="a89e72af10bfd49ff39397cd54981b8d6c2c8f86">Only alphanumeric, underscore, space and # ( ) + - characters allowed</span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div class="col-12 mb-3">
        <tsl-checkbox [formControl]="skipResidenceCountryControl">
            <span style="white-space: break-spaces; line-height: 18px;" i18n="@@DoNotWishToProvideResidenceCountry" t="DoNotWishToProvideResidenceCountry">I do not wish to provide the country of residence for this contact.</span>
        </tsl-checkbox>
    </div>

    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@CountryOfResidence" t="CountryOfResidence">Country of Residence</tsl-label>
            <tsl-select shape="round" placeholder="Country of Residence" tPlaceholder="CountryOfResidence" i18n-placeholder="@@CountryOfResidence" [formControl]="residenceCountryControl">
                <tsl-option>Select</tsl-option>
                <tsl-option *ngFor="let country of countries$ | async | sortBy: 'asc': 'Name'"
                    [value]="country.abbreviation">
                    {{ translate.get(country.name) }}
                </tsl-option>
            </tsl-select>
            <tsl-error *ngIf="residenceCountryControl.errors && (residenceCountryControl.dirty || residenceCountryControl.touched)">
                <span i18n="@@CountryOfResidenceIsRequired"
                    t="CountryOfResidenceIsRequired">Country of residence is required</span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div *ngIf="!defaultContactTypes" class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@4b8f49e1a68db0233c23ba28ff45a328f53aebfb" t="4b8f49e1a68db0233c23ba28ff45a328f53aebfb">Contact Purpose</tsl-label>
            <tsl-select multiple shape="round" placeholder="Contact Purpose" [formControl]="contactTypesControl"
                tPlaceholder="4b8f49e1a68db0233c23ba28ff45a328f53aebfb" i18n-placeholder="@@4b8f49e1a68db0233c23ba28ff45a328f53aebfb">
                <tsl-optgroup *ngFor="let group of contactTypeGroups" [label]="group.name">
                    <tsl-option *ngFor="let type of group.types" [value]="type.id" [disabled]="disableContactType(type)"
                        withArrow="true" tslTooltipPosition="Right" [tslTooltip]="getCategoryTooltip(type.id)">
                        {{ translate.get(type.id)}}</tsl-option>
                </tsl-optgroup>
            </tsl-select>
            <tsl-error
                *ngIf=" contactTypesControl.errors && ( contactTypesControl.dirty ||  contactTypesControl.touched)">
                <span i18n="@@bac382c02b9ae2cc9877e1a1171f8ae901f40b74" t="bac382c02b9ae2cc9877e1a1171f8ae901f40b74">Contact Purpose is Required </span>
            </tsl-error>
        </tsl-form-field>
    </div>

    <div class="col-6" *ngIf="showIsPrimaryCheckbox">
        <tsl-checkbox [(ngModel)]="ismarkedPrimary" (change)="onPrimaryContactChange($event.checked)"> <span style="margin-left: 10px;" class="row tsl-error text-left" i18n="@@1733649792073517554" t="1733649792073517554">Are you a Primary Contact?</span></tsl-checkbox>
    </div>

    <div class="col-6">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@c5bb9f8936cb33db2ca351a1b87a984fdf11917c" t="c5bb9f8936cb33db2ca351a1b87a984fdf11917c">Comments</tsl-label>
            <textarea tslInput fullWidth shape="rectangle" type="text" placeholder="Comments"
                [formControl]="commentsControl" maxlength="100" tPlaceholder="c5bb9f8936cb33db2ca351a1b87a984fdf11917c" i18n-placeholder="@@c5bb9f8936cb33db2ca351a1b87a984fdf11917c"></textarea>
            <tsl-hint align="end" class="max-length-hint">{{commentsControl.value?.length || 0}} / 100
            </tsl-hint>
        </tsl-form-field>
    </div>
</div>
<div class="row" *ngIf="requiredDocuments?.length > 0">
    <div class="col-12">
        <documents-grid #contactDocumentsGrid [tsl-supplierCode]="supplierCode" [tsl-documents]="requiredDocuments" [tsl-disableValidations]="disableDocumentValidations" [tsl-readOnly]="readOnly">
        </documents-grid>
    </div>
</div>
<div class="mt-4 text-left">
    <button *ngIf="!hideCancelButton" tsl-button size="small" color="black" outline (click)="cancel()">{{
        translate.get(cancelBtnLabel) }}</button>
    <button *ngIf="!hideSaveBtn" tsl-button size="small" color="blue" outline (click)="submit()">{{
        translate.get(saveBtnLabel) }}</button>
</div>